'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _msg = require('./msg');

var _msg2 = _interopRequireDefault(_msg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _msg2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/msg/index.js
// module id = 2253
// module chunks = 0